export default `
query QueryResponsesByServiceProviderId($serviceProviderId: ID!, $from: Float, $to: Float, $after: ID) {
    queryInstancesByServiceProviderIdCreatedAtIndex(serviceProviderId: $serviceProviderId, from: $from, to: $to, after: $after) {
    nextToken
    items {
      instanceId
      createdAt
      propertyId    
      serviceProviderId
      processed
    }
  }
}
`;
